import Axios from "@/plugins/axios";
import { addPendingNews, getAllPendingNews, deletePendingNews, countPendingNews } from '@/utils/offlineNewsDb';

let listenerRegistered = false;

export default {
    namespaced: true,
    state: {
        isOnline: navigator.onLine,
        pendingCount: 0,
        isSyncing: false,
    },
    mutations: {
        setOnlineStatus(state, isOnline) {
            state.isOnline = isOnline;
        },
        setPendingCount(state, count) {
            state.pendingCount = count;
        },
        setSyncing(state, isSyncing) {
            state.isSyncing = isSyncing;
        },
    },
    actions: {
        initNetworkListener({ commit, dispatch }) {
            if (listenerRegistered) {
                return;
            }
            listenerRegistered = true;
            // sync is manual only (via the "sync now" button) - we just track online status here,
            // e.g. so the button can be disabled while actually offline
            window.addEventListener('online', () => {
                commit('setOnlineStatus', true);
            });
            window.addEventListener('offline', () => {
                commit('setOnlineStatus', false);
            });
            dispatch('refreshPendingCount');
        },
        async refreshPendingCount({ commit }) {
            const count = await countPendingNews();
            commit('setPendingCount', count);
        },
        async queueNews({ dispatch }, payload) {
            await addPendingNews(payload);
            await dispatch('refreshPendingCount');
        },
        async syncPending({ commit, dispatch, state }) {
            if (!state.isOnline || state.isSyncing) {
                return;
            }
            commit('setSyncing', true);
            const records = await getAllPendingNews();
            for (const record of records) {
                try {
                    await Axios.post('newsboard', record.payload);
                    await deletePendingNews(record.id);
                } catch (err) {
                    if (!err.response) {
                        // still offline (or connection dropped again) - stop and retry later
                        break;
                    }
                    // server-side rejection (e.g. validation) - leave it out of the way, move on
                    console.log(err);
                }
            }
            await dispatch('refreshPendingCount');
            commit('setSyncing', false);
        },
    },
}
